// extracted by mini-css-extract-plugin
export default {"pageWrapper":"AnimatedContainer_pageWrapper__VTPcN","container":"AnimatedContainer_container__7He+C","borderGlow":"AnimatedContainer_borderGlow__UznIM"};